var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Pubsub_subscribers;
import { Machina } from './machina.js';
class Pubsub {
    constructor() {
        _Pubsub_subscribers.set(this, new Map());
    }
    subscribe(topic) {
        if (!__classPrivateFieldGet(this, _Pubsub_subscribers, "f").has(topic)) {
            __classPrivateFieldGet(this, _Pubsub_subscribers, "f").set(topic, new Set());
        }
        const machina = new Machina();
        __classPrivateFieldGet(this, _Pubsub_subscribers, "f").get(topic).add(machina);
        return {
            stream: () => machina.stream(),
            close: () => {
                __classPrivateFieldGet(this, _Pubsub_subscribers, "f").get(topic)?.delete(machina);
                machina.close();
            },
        };
    }
    publish(topic, data) {
        if (!__classPrivateFieldGet(this, _Pubsub_subscribers, "f").has(topic))
            return;
        for (const machina of __classPrivateFieldGet(this, _Pubsub_subscribers, "f").get(topic)) {
            machina.push(data);
        }
    }
    close() {
        for (const subscribers of __classPrivateFieldGet(this, _Pubsub_subscribers, "f").values()) {
            for (const machina of subscribers) {
                machina.close();
            }
        }
        __classPrivateFieldGet(this, _Pubsub_subscribers, "f").clear();
    }
}
_Pubsub_subscribers = new WeakMap();
export { Pubsub };
